<template>
  <div>
    <div class="div-title uppercase text-center pb-3.5 border-b border-b-gray-200 mb-8">
      <h1 class="text-4xl">
        checkout
      </h1>
      <template v-if="Object.keys(errors).length">
        <div v-for="(messages, field) in errors" :key="field">
          <admin-notification
              color="danger"
              v-for="message in messages"
          >
            {{ message }}
          </admin-notification>
        </div>
      </template>
    </div>

    <div v-show="ready && !finish">
      <div class="flex flex-col-reverse lg:flex-row">
        <div class=" lg:basis-2/4 sm:py-4 sm:px-8">
          <div class="mb-10 border p-2 sm:py-4 sm:px-8 " :class="step === 0 ? 'border-black':'bg-gray-50 border-stone-200'">
            <h3 class="font-bold text-4xl uppercase mb-4" @click="step = 0" :class="step === 0 ? '':'text-stone-400'">Billing Address</h3>
            <div class="content-billing-address" v-show="step === 0" >
              <V-Form :validation-schema="schemaUser" ref="userForm">
                <div class="flex flex-row">
                  <front-field
                      label="First Name *" upperText class="mx-1 sm:mx-4 text-grayMedium font-semibold text-tiny basis-2/4 mb-5"
                  >
                    <front-control
                        v-model="formUser.first_name"
                        name="first_name"
                        type="text"
                        borderbottom
                        borderradiusnone
                        class="text-black font-semibold"
                    />
                  </front-field>
                  <front-field
                      label="Last Name *" upperText class="mx-1 sm:mx-4 text-grayMedium font-semibold text-tiny basis-2/4 mb-5"
                  >
                    <front-control
                        v-model="formUser.last_name"
                        name="last_name"
                        type="text"
                        borderbottom
                        borderradiusnone
                        class="text-black font-semibold"
                    />
                  </front-field>
                </div>
                <div class="flex flex-row">
                  <front-field
                      label="Phone *" upperText class="mx-1 sm:mx-4 text-grayMedium font-semibold text-tiny basis-2/4 mb-5"
                  >
                    <front-control
                        v-model="formUser.phone_number"
                        name="phone_number"
                        type="tel"
                        :country="formUser.country"
                        borderbottom
                        borderradiusnone
                        class="text-black font-semibold"
                    />
                  </front-field>
                  <front-field
                      label="Email *" upperText class="mx-1 sm:mx-4 text-grayMedium font-semibold text-tiny basis-2/4 mb-5"
                  >
                    <front-control
                        v-model="formUser.email"
                        name="email"
                        type="text"
                        disabled
                        borderbottom
                        borderradiusnone
                        class="text-black font-semibold"
                    />
                  </front-field>
                </div>
                <front-field
                    label="Company" upperText class="mx-1 sm:mx-4 text-grayMedium font-semibold text-tiny basis-2/4 mb-5"
                >
                  <front-control
                      v-model="formUser.company"
                      name="company"
                      type="text"
                      borderbottom
                      borderradiusnone
                  />
                </front-field>
                <ButtonsAddressFieldGroup
                    v-model:address="formUser.address"
                    v-model:city="formUser.city"
                    v-model:state="formUser.state"
                    v-model:country="formUser.country"
                    v-model:zip_code="formUser.zip_code"
                    v-model:messageZip_code="formUser.zip_code_message"
                    v-model:state_message="formUser.state_message"
                    :country_options="countries"
                    :state_options="statesUser"
                    name="address"
                    class="mx-1 sm:mx-4 text-grayMedium font-semibold text-tiny basis-2/4 mb-5"
                    borderbottom
                    upperText
                    borderradiusnone
                    front required
                ></ButtonsAddressFieldGroup>
                <front-field
                    label="Address 2:" upperText class="mx-1 sm:mx-4 text-grayMedium font-semibold text-tiny basis-2/4 mb-5"
                >
                  <front-control
                      v-model="formUser.address2"
                      name="address2"
                      type="text"
                      borderbottom

                      borderradiusnone
                      class="text-black font-semibold"
                  />
                </front-field>

                <div class="flex flex-row">
                  <front-field
                      label="Country *" upperText class="mx-1 sm:mx-4 text-grayMedium font-semibold text-tiny basis-2/4 mb-5"
                  >
                    <front-v-select
                        v-model="formUser.country"
                        :options="countries"
                        reduce="id"
                        name="country"
                        borderbottom
                        borderradiusnone
                        class="text-black font-semibold"
                    />
                  </front-field>
                  <front-field
                      label="State *" upperText class="mx-1 sm:mx-4 text-grayMedium font-semibold text-tiny basis-2/4 mb-5"
                  >
                    <div>
                      <front-v-select
                          v-model="formUser.state"
                          :options="statesUser"
                          name="state"
                          reduce="name"
                          borderbottom
                          borderradiusnone
                          class="text-black font-semibold"
                      />
                      <p class="text-red-600" v-show="(formUser.state_message)">
                        {{ formUser.state_message }}
                      </p>
                    </div>
                  </front-field>
                </div>
                <div class="flex flex-row">
                  <front-field
                      label="City *" upperText class="mx-1 sm:mx-4 text-grayMedium font-semibold text-tiny basis-2/4 mb-5"
                  >
                    <front-control
                        v-model="formUser.city"
                        name="city"
                        type="text"
                        borderbottom
                        borderradiusnone
                        class="text-black font-semibold"
                    />
                  </front-field>
                  <front-field
                      label="Zip / Postal Code *" upperText class="mx-1 sm:mx-4 text-grayMedium font-semibold text-tiny basis-2/4 mb-5"
                  >
                    <div>
                      <front-control
                          v-model="formUser.zip_code"
                          name="zip_code"
                          type="text"
                          borderbottom
                          borderradiusnone
                          class="text-black font-semibold"
                      />
                      <p class="text-red-600" v-show="(formUser.zip_code_message)">
                        {{ formUser.zip_code_message }}
                      </p>
                    </div>
                  </front-field>
                </div>
                <front-check-radio-picker
                    class="mb-5 font-bold"
                    v-if="orderType === 2"
                    v-model="formShipping.same_as_address"
                    name="formShippingSame_as_address"
                    type="checkbox"
                    :options="{ one: 'Ship Items to the Above Billing Address'}"
                />
              </V-Form>
              <div class="my-4 text-center">
                <front-jb-button v-if="Number(formOrder.total) !== 0"
                    label="Save and Continue"
                    class="rounded-r-none uppercase min-w-[240px] p-2.5 text-white"
                    type="Save"
                    color="blackNatonal"
                    @click="nextStep"
                />
                <front-jb-button v-else
                    label="Submit Payment"
                    class="rounded-r-none min-w-[240px] p-2.5 text-white"
                    type="Save"
                    color="blackNatonal"
                    @click="onSubmit"
                />
              </div>
            </div>
          </div>

          <div class="grid-layout box-shipping mb-10 border sm:py-4 p-2 sm:px-8" :class="step === 1 ? 'border-black':'bg-gray-50 border-stone-200'" v-if="!formShipping.same_as_address && orderType === 2">
            <div class="mb-10 text-black">
              <h3 class="font-bold text-4xl uppercase" @click="step = 1" :class="step === 1 ? '':'text-stone-400'">Shipping Address</h3>
              <div class="content-shipping-address" v-show="step === 1">
                <div class="p-1 sm:p-4 mx-1 sm:mx-4 my-3 rounded-lg" :class="{ 'border-black': showBorder === false }">
                  <template v-for="(shipAddress,index) in shippingAddresses">
                    <fieldset class="mb-5 flex justify-between border-b border-b-grayLight2 py-4" >
                      <div class="flex">
                        <input :id="'draft'+index"  class="mr-2 w-[10px] sm:w-[35px]" type="radio" name="status" :checked="shipAddress.id === formShipping.id" @click="changeShippingAddress(shipAddress.id,false)" />
                        <label :for="'draft'+index" class="peer-checked/draft:text-dark">
                          <div class="flex flex-col" >
                            <div>
                              <p class="font-bold">{{shipAddress.first_name}}</p>
                            </div>
                            <div class="flex flex-row flex-wrap">
                              <p>{{shipAddress.last_name}}</p>,
                              <p>{{shipAddress.address}}</p>,
                              <p>{{shipAddress.city}}</p>,
                              <p>{{shipAddress.state}}</p>,
                              <p>{{shipAddress.zip_code}}</p>,
                              <p>{{shipAddress.country}}</p>
                            </div>
                          </div>
                        </label>
                      </div>
                      <div >
                        <img src="/icons/pencil.svg" alt="pencil image" class="w-4 h-4" @click="changeShippingAddress(shipAddress.id,true)">
                      </div>
                    </fieldset>

                    <div v-show="showShippingForm" v-if="shipAddress.id === formShipping.id">
                      <V-Form :validation-schema="schemaShipping"
                              ref="shippingForm">
                        <front-field
                            label="First Name *:"
                        >
                          <front-control
                              v-model="formShipping.first_name"
                              name="first_nameShipping"
                              type="text"
                              borderbottom
                              borderradiusnone
                          />
                        </front-field>
                        <front-field
                            label="Last Name *:"
                        >
                          <front-control
                              v-model="formShipping.last_name"
                              name="last_nameShipping"
                              type="text"
                              borderbottom
                              borderradiusnone
                          />
                        </front-field>
                        <front-field
                            label="Company :"
                        >
                          <front-control
                              v-model="formShipping.company"
                              name="companyShipping"
                              type="text"
                              borderbottom
                              borderradiusnone
                          />
                        </front-field>
                        <ButtonsAddressFieldGroup
                            v-model:address="formShipping.address"
                            v-model:city="formShipping.city"
                            v-model:state="formShipping.state"
                            v-model:country="formShipping.country"
                            v-model:zip_code="formShipping.zip_code"
                            v-model:messageZip_code="formShipping.zip_code_message"
                            v-model:state_message="formShipping.state_message"
                            :country_options="countries"
                            :state_options="statesShipping"
                            name="addressShipping"
                            class="mb-2 last:mb-0 text-grayMedium text-tiny"
                            borderbottom
                            borderradiusnone
                            front required
                        ></ButtonsAddressFieldGroup>
                        <front-field
                            label="Address 2:"
                        >
                          <front-control
                              v-model="formShipping.address2"
                              name="address2Shipping"
                              type="text"
                              borderbottom
                              borderradiusnone
                          />
                        </front-field>
                        <front-field
                            label="Country :"
                        >
                          <front-v-select
                              v-model="formShipping.country"
                              :options="countries"
                              reduce="id"
                              name="countryShipping"
                              borderbottom
                              borderradiusnone
                          />
                        </front-field>
                        <front-field
                            label="City:"
                        >
                          <front-control
                              v-model="formShipping.city"
                              name="cityShipping"
                              type="text"
                              borderbottom
                              borderradiusnone
                          />
                        </front-field>
                        <front-field
                            label="State :"
                        >
                          <div>
                            <front-v-select
                                v-model="formShipping.state"
                                :options="statesShipping"
                                name="stateShipping"
                                reduce="name"
                                borderbottom
                                borderradiusnone
                            />
                            <p class="text-red-600" v-show="(formShipping.state_message)">
                              {{ formShipping.state_message }}
                            </p>
                          </div>
                        </front-field>
                        <front-field
                            label="Zip / Postal Code:"
                        >
                          <div>
                            <front-control
                                v-model="formShipping.zip_code"
                                name="zip_codeShipping"
                                type="text"
                                borderbottom
                                borderradiusnone
                            />
                            <p class="text-red-600" v-show="(formShipping.zip_code_message)">
                              {{ formShipping.zip_code_message }}
                            </p>
                          </div>
                        </front-field>
                        <front-field
                            label="Phone :"
                        >
                          <front-control
                              v-model="formShipping.phone_number"
                              name="phone_numberShipping"
                              type="tel"
                              class="mb-4"
                              :country="formShipping.country"
                              borderbottom
                              borderradiusnone
                          />
                        </front-field>
                      </V-Form>
                    </div>
                  </template>
<!--                  <fieldset class="mb-5 flex">-->
<!--                    <input :id="'draft'" class=" mr-1" type="radio" name="status" @click="changeShippingAddress(0,true)" />-->
<!--                    <label :for="'draft'" class="peer-checked/draft:text-dark font-bold">-->
<!--                      <div class="flex" >-->

<!--                      </div>-->
<!--                    </label>-->
<!--                  </fieldset>-->



                  <div class="flex items-center mb-4" @click="changeShippingAddress(0,true)">
                    <img src="/icons/plus.svg" class="mr-2 w-4 h-4 cursor-pointer" alt="plus svg" >
                    <p class="underline font-bold">add a new shipping address</p>
                  </div>
                  <div v-show="showShippingForm" v-if="!formShipping.id">
                    <V-Form :validation-schema="schemaShipping"
                            ref="shippingForm">
                      <front-field
                          label="First Name *:"
                      >
                        <front-control
                            v-model="formShipping.first_name"
                            name="first_nameShipping"
                            type="text"
                            borderbottom
                            borderradiusnone
                        />
                      </front-field>
                      <front-field
                          label="Last Name *:"
                      >
                        <front-control
                            v-model="formShipping.last_name"
                            name="last_nameShipping"
                            type="text"
                            borderbottom
                            borderradiusnone
                        />
                      </front-field>
                      <front-field
                          label="Company :"
                      >
                        <front-control
                            v-model="formShipping.company"
                            name="companyShipping"
                            type="text"
                            borderbottom
                            borderradiusnone
                        />
                      </front-field>
                      <ButtonsAddressFieldGroup
                          v-model:address="formShipping.address"
                          v-model:city="formShipping.city"
                          v-model:state="formShipping.state"
                          v-model:country="formShipping.country"
                          v-model:zip_code="formShipping.zip_code"
                          v-model:messageZip_code="formShipping.zip_code_message"
                          v-model:state_message="formShipping.state_message"
                          :country_options="countries"
                          :state_options="statesShipping"
                          name="addressShipping"
                          class="mb-2 last:mb-0 text-tiny"
                          borderbottom
                          borderradiusnone
                          front required
                      ></ButtonsAddressFieldGroup>
                      <front-field
                          label="Address 2:"
                      >
                        <front-control
                            v-model="formShipping.address2"
                            name="address2Shipping"
                            type="text"
                            borderbottom
                            borderradiusnone
                        />
                      </front-field>
                      <front-field
                          label="Country :"
                      >
                        <front-v-select
                            v-model="formShipping.country"
                            :options="countries"
                            reduce="id"
                            name="countryShipping"
                            borderbottom
                            borderradiusnone
                        />
                      </front-field>
                      <front-field
                          label="City:"
                      >
                        <front-control
                            v-model="formShipping.city"
                            name="cityShipping"
                            type="text"
                            borderbottom
                            borderradiusnone
                        />
                      </front-field>
                      <front-field
                          label="State :"
                      >
                        <div>
                          <front-v-select
                              v-model="formShipping.state"
                              :options="statesShipping"
                              name="stateShipping"
                              reduce="name"
                              borderbottom
                              borderradiusnone
                          />
                          <p class="text-red-600" v-show="(formShipping.state_message)">
                            {{ formShipping.state_message }}
                          </p>
                        </div>
                      </front-field>
                      <front-field
                          label="Zip / Postal Code:"
                      >
                        <div>
                          <front-control
                              v-model="formShipping.zip_code"
                              name="zip_codeShipping"
                              type="text"
                              borderbottom
                              borderradiusnone
                          />
                          <p class="text-red-600" v-show="(formShipping.zip_code_message)">
                            {{ formShipping.zip_code_message }}
                          </p>
                        </div>
                      </front-field>
                      <front-field
                          label="Phone :"
                      >
                        <front-control
                            v-model="formShipping.phone_number"
                            name="phone_numberShipping"
                            type="tel"
                            class="mb-4"
                            :country="formShipping.country"
                            borderbottom
                            borderradiusnone
                        />
                      </front-field>
                    </V-Form>
                  </div>
                </div>
                <div class="my-4 text-center">
                  <front-jb-button
                      label="save and Continue"
                      class="rounded-r-none min-w-[240px] p-2.5 text-white"
                      type="Save"
                      color="blackNatonal"
                      @click="nextStep"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="my-3 box-payment border  py-4 px-8" :class="step === 2 ? 'border-black':'bg-gray-50 border-stone-200'" v-show="Number(formOrder.total) !== 0">
            <h3 class="font-bold text-3xl px-2 sm:text-4xl mb-5 uppercase" @click="step = 2" :class="step === 2 ? '':'text-stone-400'">select payment method</h3>
            <div class="content-payment-method" v-show="step === 2">
              <div class="border-2 mb-4 rounded-lg border-black p-3">
                <V-Form
                    @submit="onSubmit"
                    :validation-schema="schemaPayment"
                    ref="paymentForm"
                >
                  <front-field
                      label="Card Number"
                      upperText
                  >
                    <front-control
                        v-model="formCard.cardNumber"
                        name="cardNumber"
                        type="text"
                        maxlength="16"
                        borderbottom
                        borderradiusnone
                    />
                  </front-field>
                  <div class="grid grid-cols-3 gap-3">
                    <front-field
                        label="Expiration Date"
                        upperText
                        class="col-span-2"
                    >
                      <div class="grid grid-cols-2 gap-2">
                        <front-control
                            v-model="formCard.cardMonth"
                            name="cardMonth"
                            type="select"
                            :options="card_months"
                            borderbottom
                            borderradiusnone
                        />
                        <front-control
                            v-model="formCard.cardYear"
                            name="cardYear"
                            type="select"
                            :options="card_years"
                            borderbottom
                            borderradiusnone
                        />
                      </div>
                    </front-field>
                    <front-field
                        label="CVV"
                        upperText
                    >
                      <front-control
                          v-model="formCard.cardCvv"
                          name="cardCvv"
                          type="text"
                          maxlength="4"
                          borderbottom
                          borderradiusnone
                      />
                    </front-field>
                  </div>
                  <front-field v-if="show_auto_renewal">
                    <admin-check-radio-picker
                        v-model="formCard.autoRenewal"
                        name="email"
                        type="checkbox"
                        :options="{ one: 'Print subscription automated renewal'}"
                    />
                  </front-field>
                  <admin-divider/>
                </V-Form>

              </div>
              <div class="my-4 text-center">
                <front-jb-button
                    label="Submit Payment"
                    class="rounded-r-none min-w-[240px] p-2.5 text-white"
                    type="Save"
                    color="blackNatonal"
                    @click="onSubmit"
                />
              </div>
            </div>
          </div>

        </div>
        <div class="lg: basis-2/4  relative mb-4 sm:mb-0">
          <div class="sticky top-3 sm:py-4 sm:px-8 bg-gray-50">
            <h3 class="font-bold p-2 text-3xl sm:text-4xl mb-5 uppercase">order summary</h3>
            <div class="p-2 sm:p-4 border-b-gray-300 font-bold">

              <div class="container mb-5">
                <div class="flex flex-row mb-3 border-b-2 border-black uppercase">
                  <div class="grow text-tiny sm:text-base font-medium sm:font-bold px-1">Item Name</div>
                  <div class="min-w-[70px] text-center sm:w-[120px] text-tiny sm:text-base font-medium sm:font-bold px-1">qty</div>
                  <div class="min-w-[60px] text-center sm:w-[80px] text-tiny sm:text-base font-medium sm:font-bold">Price</div>
                  <div class="min-w-[80px] text-center text-tiny sm:text-base font-medium sm:font-bold">Total</div>
                  <div class="min-w-[35px] "></div>
                </div>
                <div class="flex flex-row mb-4 border-b border-grayLight2 py-2 min-h-[62px]"  v-for="(product,index) in cartProducts"
                     :key="product.cartId" >
                  <div class="text-xs sm:text-base grow px-1 font-normal">
                    {{ product.name }}
<!--                    <span v-if=" product.campaign_id > 0 && product.discount > 0 " class="text-red-500"> - ${{product.discount}} </span>-->
                    <div class="font-bold" v-if="product.option_name">
                      <span v-if="product.option_name.length>0">{{ product.option_name }}</span>
                    </div>
                  </div>
                  <div class="min-w-[70px] sm:min-w-[120px] px-1">
                    <div v-if="product.category !== 1 && (product.category !== 2 && product.category_option !== 4)" class="relative border-none max-h-6">

                      <div class="flex items-center">
                        <img src="/icons/minus.svg"  @click="cartQuantity(product.cartId,'-')" class="mr-1 sm:mr-2 w-2.5 h-2.5 sm:w-3 sm:h-3 cursor-pointer" alt="plus svg" >
                        <div class="mr-1 min-w-[30px]  sm:min-w-[60px] flex justify-center bg-white items-center min-h-[40px] text-center text-xl border border-gray-300-">{{ product.quantity }}</div>
                        <img src="/icons/plus.svg"  @click="cartQuantity(product.cartId,'+')" class="mr-1 sm:mr-2 w-2.5 h-2.5 sm:w-3 sm:h-3 cursor-pointer" alt="plus svg" >
                      </div>
                      <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2">
                        <i class="fas fa-chevron-down text-gray-400"></i>
                      </div>
                    </div>
                    <div v-else>
                      {{ product.quantity }}
                    </div>
                  </div>


                  <div class="min-w-[60px] sm:min-w-[80px] font-normal sm:font-medium flex items-center justify-center font-tiny sm:font-base">
                    ${{ product.price }}
                  </div>
                  <div class="min-w-[80px] flex font-normal  sm:font-medium font-tiny sm:font-base items-center justify-center">
                    ${{ (product.price * product.quantity).toFixed(2) }}
                  </div>
                  <div class="min-w-[35px] flex items-center justify-center">
                    <div @click="removeFromCart(product.cartId)">
                      <img width="18" height="18" src="/icons/delete.svg" alt="instagram logo">
                    </div>
                  </div>
                </div>
              </div>

              <div class="flex flex-col sm:flex-row justify-between font-medium">
                <div class="flex justify-start flex-col sm:flex-row">
                  <div class="flex my-1 sm:my-0.5 items-start flex-col">
                    <div class="flex">
                      <front-field
                          label="Promo Code:"
                          v-if="applied_voucher"
                          class="font-medium w-full"
                      >
                        <front-control
                            v-model="formBilling.voucher_code"
                            name="voucher_code1"
                            type="text"
                            disabled
                            borderbottom
                            borderradiusnone
                        />
                      </front-field>
                      <front-field
                          class="bg-gray-50"
                          v-else
                      >
                        <front-control
                            v-model="formBilling.voucher_code"
                            name="voucher_code2"
                            placeholder="Add Promo Code:"
                            type="text"
                            borderbottom
                            class="font-medium"
                            borderradiusnone
                        />
                      </front-field>
                      <div>
                        <!--                    <front-jb-button-->
                        <!--                        label="Remove"-->
                        <!--                        class="rounded-r-none bg-blackLight p-1.5 font-bold capitalize mr-1 font-title"-->
                        <!--                        color="blackNatonal"-->
                        <!--                        small-->
                        <!--                        @click="removeVoucher()"-->
                        <!--                    />-->
                        <front-jb-button
                            label="Apply"
                            class="bg-blackLight p-1 font-bold capitalize font-sans ml-2 min-h-[40px]"
                            color="blackNatonal"
                            @click="applyVoucher()"
                        />
                      </div>
                    </div>

                    <p class="text-red-500 w-full" >{{ voucher_message }}</p>
                  </div>

                </div>
                <div class="flex flex-col justify-end min-w-[240px] mt-6">
                  <div class="flex flex-row text-right">
                    <div class="basis-2/4">
                      <p class="text-right">Sales Tax:</p>
                    </div>
                    <div class="basis-2/4">
                      <div>$ {{ parseFloat(((formOrder.subtotal - formOrder.discount > 0) ? (formOrder.subtotal - formOrder.discount) : 0) * formOrder.tax / 100).toFixed(2) }}</div>
                    </div>
                  </div>
                  <div class="flex flex-row text-right">
                    <div class="basis-2/4">
                      <p>Shipping Fee:</p>
                    </div>
                    <div class="basis-2/4">
                      <div>$ {{ parseFloat(formOrder.shipping_tax).toFixed(2) }}</div>
                    </div>
                  </div>
                  <div class="flex flex-row text-right">
                    <div class="basis-2/4">
                      <p>Transaction Tax:</p>
                    </div>
                    <div class="basis-2/4">
                      <div>$ {{ parseFloat(formOrder.surcharge_amount).toFixed(2) }}</div>
                    </div>
                  </div>
                  <div class="flex flex-row text-right font-extrabold text-3xl">
                    <div class="basis-2/4">
                      <p>Subtotal:</p>
                    </div>
                    <div class="basis-2/4">
                      <div>$ {{ parseFloat(formOrder.subtotal).toFixed(2) }}</div>
                    </div>
                  </div>
                  <div class="flex flex-row text-right font-extrabold text-3xl">
                    <div class="basis-2/4">
                      <p>Total:</p>
                    </div>
                    <div class="basis-2/4">
                      <div>$ {{ formOrder.total }}</div>
                    </div>
                  </div>
                  <div v-if="formOrder.discount > 0" >
                    <div class="flex justify-between">
                      <p>Discount:</p>
                      <div>$ {{ parseFloat(formOrder.discount).toFixed(2) }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="!ready">
      <LoadersSpinner/>
    </div>
    <div v-if="finish">
      <div class="w-full flex justify-center items-center font-bold text-4.3xl min-h-[40vh]">
        <p>Congratulations! You will receive an email with the details! </p>
        <NuxtLink v-if="digital_photos" :to="'/users/digital-photos?transaction='+digital_photos">
         <span class="ml-1 text-green-500 hover:text-blue-500"> Click here </span> to download the photos.
        </NuxtLink>

      </div>

    </div>

  </div>
</template>

<script setup>

import {http} from "~/utils/http";
import { mdiPlus, mdiMinus} from '@mdi/js'
import {computed, onMounted, ref} from "vue";
import {useMainStore} from '~/stores/main'
import {navigateTo, useHead} from "nuxt/app";
import {OrderInfo, OrderInformation, PaymentCard} from "~/composables/nhTypes";
import * as Yup from "yup";
import {useSiteTitle} from "../../composables/state";
import router from "#app/plugins/router.mjs";

const schemaUser = Yup.object().shape({
  'first_name': Yup.string().trim().required().nullable().nullable().label('First name'),
  'last_name': Yup.string().trim().required().nullable().nullable().label('Last name'),
  'address': Yup.string().trim().required().nullable().nullable().label('Address'),
  'country': Yup.string().trim().required().nullable().nullable().label('Country'),
  'city': Yup.string().trim().required().nullable().nullable().label('City'),
  'state': Yup.string().trim().required().nullable().nullable().label('State'),
  'zip_code': Yup.string().trim().required().nullable().nullable().label('Zip Code'),
  'phone_number': Yup.string().trim().required().nullable().nullable().label('Phone'),
  'email': Yup.string().trim().required().nullable().nullable().label('Email'),
});

const schemaShipping = Yup.object().shape({
  'first_nameShipping': Yup.string().trim().required().nullable().nullable().label('First name'),
  'last_nameShipping': Yup.string().trim().required().nullable().nullable().label('Last name'),
  'addressShipping': Yup.string().trim().required().nullable().nullable().label('Address'),
  'countryShipping': Yup.string().trim().required().nullable().nullable().nullable().label('Country'),
  'cityShipping': Yup.string().trim().required().nullable().nullable().label('City'),
  'stateShipping': Yup.string().trim().required().nullable().nullable().label('State'),
  'phone_numberShipping': Yup.string().trim().required().nullable().nullable().label('Phone'),
  'zip_codeShipping': Yup.string().trim().required().nullable().nullable().label('Zip Code'),
});

const schemaPayment = Yup.object().shape({
  'cardNumber': Yup.number().typeError('Card Number is invalid').required().nullable().label('Card Number'),
  'cardMonth': Yup.number().typeError('Month is invalid').required().nullable().label('Month').test('Month', function () {
    return formCard.value.cardMonth > 0;
  }),
  'cardYear': Yup.number().typeError('Year is invalid').required().nullable().label('Year').test('Year', function () {
    return formCard.value.cardYear > 0;
  }),
  'cardCvv': Yup.number().typeError('Cvv is invalid').required().nullable().label('Cvv'),
});

const mainStore = useMainStore()
const voucher_message = ref('');
const step = ref(0);
const showBorder = ref(false);
const applied_voucher = ref(false);
const ready = ref(false);
const finish = ref(false);
const taxes = ref([]);
const states = ref([]);
const countries = ref([]);
const formOrder = ref(new OrderInfo())
const formUser = ref(new OrderInformation())
const formBilling = ref(new OrderInformation())
const formShipping = ref(new OrderInformation())
const shippingAddresses = ref([]);
const showShippingForm = ref(false);
const userForm = ref(null);
const shippingForm = ref(null);
const paymentForm = ref(null);
const orderType = ref(1);
const formCard = ref(new PaymentCard());
const shipping_options = ref([{id: 0, name: 'Add a new shipping address'}]);
const selectedShipping = ref(0);
const errors = ref([]);
const card_years = ref([{id: 0, name: 'Year'}]);
const card_months = ref([
  {id: 0, name: 'Month'},
  {id: '01', name: '01'},
  {id: '02', name: '02'},
  {id: '03', name: '03'},
  {id: '04', name: '04'},
  {id: '05', name: '05'},
  {id: '06', name: '06'},
  {id: '07', name: '07'},
  {id: '08', name: '08'},
  {id: '09', name: '09'},
  {id: '10', name: '10'},
  {id: '11', name: '11'},
  {id: '12', name: '12'}]);

const discountProducts = ref([]);

const cartProducts = computed(() => {
  let products = [];

  products = mainStore.cartProducts;

    // mainStore.cartProducts.forEach((product)=>{
    //   if(discountProducts.value.length > 0)
    //   {
    //   discountProducts.value.forEach((discount_product)=>{
    //     if(product.cartId == discount_product.cartId)
    //     {
    //       if(discount_product.campaign_id > 0)
    //       {
    //         product.campaign_id = discount_product.campaign_id;
    //         product.discount = discount_product.discount;
    //         products.push(product);
    //       }
    //       else{
    //         product.campaign_id = 0;
    //         product.discount = 0;
    //         products.push(product);
    //       }
    //     }
    //   })
    //   }
    //   else{
    //     product.campaign_id = 0;
    //     product.discount = 0;
    //     products.push(product);
    //   }
    // })
  return products;
})

const subTotal = computed(() => {
  let total = 0;
  cartProducts.value.forEach((item) => {
    total += item.quantity * item.price;
  });
  return total;
})
const siteTitle = useSiteTitle();
const route = useRoute()
const shipping_id = ref(route.query.shipping ? route.query.shipping : null)
const digital_photos = ref(null);
const show_auto_renewal = computed(() => {
  let status = false;
  if (cartProducts.value.length > 0) {
    cartProducts.value.forEach((item) => {
      if (item.category_option === 1 && item.category === 1) {
        status = true;
        return 0;
      }
    })
  }
  return status;
});

// const getProductDiscount = (cartId) => {
//   let productDiscount = 0;
//
//   discountProducts.value.forEach((item)=>{
//     if(item.hasOwnProperty("campaign_id") && item.campaign_id > 0 && item.cartId == cartId)
//     {
//       productDiscount = item.discount;
//     }
//   })
//
//   return productDiscount;
// }

useHead({
  title: computed(()=> 'Checkout - '+ siteTitle.value ) ,
  meta: [
    {name: 'description', content: computed(()=> 'Since its beginnings in 1865, National Horseman has a long history of setting the standard for the Saddlebred industry and the show horse world.')},
    {name: 'keywords', content: computed(()=>  siteTitle.value)},
  ],
})

formOrder.value.subtotal = computed(() => {
  if (cartProducts.value.length > 0) {
    let subtotal = 0;
    cartProducts.value.forEach((item) => {
      subtotal += item.quantity * item.price;
    })
    return subtotal;
  }
  return 0;
});

formOrder.value.total = computed(() =>
{
  let subtotal = (formOrder.value.subtotal - formOrder.value.discount > 0) ?  (formOrder.value.subtotal- formOrder.value.discount) : 0;
  return parseFloat(subtotal + formOrder.value.surcharge_amount + formOrder.value.shipping_tax + subtotal * formOrder.value.tax / 100 ).toFixed(2)
}
);

formOrder.value.shipping_tax = computed(() => {
  let products = cartProducts.value.filter((item) => item.product_type === 2)

  if (products.length > 0) {
    let max_shipping_tax = 0;
    let country_shipping_tax = 0;
    let individual_shipping_tax = false;
    let order_type = 1;
    let country = formShipping.value.same_as_address ? formUser.value.country : formShipping.value.country;
    if (country) {
      let taxes_rate = taxes.value.filter((item) => item.type === 2);
      let country = formUser.value.country;
      if (!formShipping.value.same_as_address) {
        country = formShipping.value.country;
      }
      let i = taxes_rate.map((item) => item.country).indexOf(country);
      if (i >= 0 && max_shipping_tax < taxes_rate[i].amount) {
        country_shipping_tax = taxes_rate[i].amount;
      }
      products.forEach((item) => {
        if (country === 'US' && max_shipping_tax < item.shipping_tax_us && item.product_type == 2) {
          order_type = item.product_type;
          max_shipping_tax = item.shipping_tax_us;
          individual_shipping_tax = true;
        }

        if (country === 'CA' && max_shipping_tax < item.shipping_tax_ca && item.product_type == 2) {
          order_type = item.product_type;
          max_shipping_tax = item.shipping_tax_ca;
          individual_shipping_tax = true;
        }

        if (country === 'ZA' && max_shipping_tax < item.shipping_tax_za && item.product_type == 2) {
          order_type = item.product_type;
          max_shipping_tax = item.shipping_tax_za;
          individual_shipping_tax = true;
        }
        if (item.product_type == 2) {
          order_type = item.product_type;
        }
      })
    }
    orderType.value = order_type;
    if (individual_shipping_tax) {
      return max_shipping_tax;
    }
    return country_shipping_tax;
  }
  orderType.value = 1;
  return 0;
});


const nextStep = async () => {
  let valid_userForm = true;
  let valid_shippingForm = true;

  if(step.value === 0){
    if (userForm.value !== null) {
      await userForm.value.validate().then((valid) => {
        valid_userForm = valid.valid;
      });
    } else {
      valid_userForm = false;
    }
  }

  if(step.value === 1) {
    if (orderType.value === 2) {
      if (!formShipping.value.same_as_address) {
        if (shippingForm.value !== null && shippingForm.value.length > 0) {
          await shippingForm.value[0].validate().then((valid) => {
            valid_shippingForm = valid.valid;
          });
        } else {
          valid_shippingForm = false;
        }
      }
    }
  }

  if (valid_userForm && valid_shippingForm) {
    if ((step.value === 0 && orderType.value === 2 && !formShipping.value.same_as_address) || step.value === 1) {
      step.value++;
    } else if (step.value === 0) {
      step.value++;
      step.value++;
    }
  } else {
    window.scrollTo(0, 0);
    errors.value.push({message: 'Invalid Data'});
    setTimeout(() => {
      errors.value = [];
    }, 5000);
  }

}

const cartQuantity = (id, type = null) => {

  let index = cartProducts.value.map((item) => item.cartId).indexOf(id);
  if (index >= 0) {

    if (type === '+') {
      cartProducts.value[index].quantity++;
      let payload = {
        id: cartProducts.value[index].cartId,
        quantity: cartProducts.value[index].quantity
      }
      mainStore.updateProduct(payload);
    } else if (type === '-') {
      if (cartProducts.value[index].quantity > 1) {
        cartProducts.value[index].quantity--;
        let payload = {
          id: cartProducts.value[index].cartId,
          quantity: cartProducts.value[index].quantity
        }
        mainStore.updateProduct(payload);
      } else {
        removeFromCart(id);
      }
    }
  }
  if(applied_voucher.value){
    applyVoucher();
  }

}

formOrder.value.tax = computed(() => {
  let taxes_rate = taxes.value.filter((item) => item.type === 1);
  let state = formUser.value.state;
  if (!formBilling.value.same_as_address) {
    state = formBilling.value.state;
  }
  let i = taxes_rate.map((item) => item.state).indexOf(state);
  if (i >= 0) {
    return taxes_rate[i].rate;
  }
  return 0;
})

formOrder.value.surcharge_amount = computed(() => {
  let taxes_rate = taxes.value.filter((item) => item.type === 3);
  let country = formUser.value.country;
  if (!formShipping.value.same_as_address) {
    country = formShipping.value.country;
  }
  let i = taxes_rate.map((item) => item.country).indexOf(country);
  if (i >= 0) {
    formOrder.value.surcharge = taxes_rate[i].rate;
    return ((formOrder.value.subtotal - formOrder.value.discount) > 0)? ((formOrder.value.subtotal - formOrder.value.discount) * taxes_rate[i].rate / 100):0;
  }
  return 0;
})

const applyVoucher = async () => {
  if(cartProducts.value.length > 0) {
    if (formBilling.value.voucher_code) {
      await http.post('api/checkout/verify-voucher',
          {
            'voucher_code': formBilling.value.voucher_code,
            'user_id': formUser.value.id,
            'cart_products': cartProducts.value
          }
      )
          .then((response) => {
            voucher_message.value = response.data.response.message;
            formOrder.value.discount = 0;
            if (response.data.response.status === true) {
              applied_voucher.value = true;
              response.data.response.cart_products.forEach(product => {
                formOrder.value.discount += product.discount;
              })
              discountProducts.value = response.data.response.cart_products;
            }
          })
    } else {
      voucher_message.value = 'Please add a promo code!'
    }
  }
}

const removeVoucher = async () => {

  if(formBilling.value.voucher_code){
    voucher_message.value = 'Promo Code removed!';
  }
  formBilling.value.voucher_code = '';
  if (applied_voucher.value) {
    applied_voucher.value = false;
    formOrder.value.discount = 0;
  }
}
const statesUser = computed(() => {
      let i = countries.value.map((item) => item.id).indexOf(formUser.value.country);
      if (i >= 0) {
        let options = states.value.filter((item) => item.country_id === countries.value[i].country_id);
        if ((options.length > 0) && !(options.map((item) => item.name).indexOf(formUser.value.state) >= 0)) {
          formUser.value.state = null;
        }
        return options;
      } else {
        return [];
      }
    }
);

const statesShipping = computed(() => {
      let i = countries.value.map((item) => item.id).indexOf(formShipping.value.country);
      if (i >= 0) {
        let options = states.value.filter((item) => item.country_id === countries.value[i].country_id);
        if (!(options.map((item) => item.name).indexOf(formShipping.value.state) >= 0)) {
          formShipping.value.state = null;
        }
        return options;
      } else {
        formShipping.value.state = null;
        return [];
      }
    }
);

const removeFromCart = (id) => {
  mainStore.removeProduct({id: id});
  if(applied_voucher.value){
    applyVoucher();
  }
}

const changeShippingAddress = (id,show) => {
  showShippingForm.value = show;
  if (id > 0) {
    let index = shippingAddresses.value.map((item) => item.id).indexOf(id);
    formShipping.value = shippingAddresses.value[index];
  } else {
    formShipping.value = new OrderInformation();
  }

  formShipping.value.same_as_address = false;

}

const getTaxes = async () => {
  try {
    await http
        .get("/api/tax-rates")
        .then((response) => {
          taxes.value = response.data;
        });
  } catch (e) {
    console.log(e);
  }
}

const getStates = async () => {
  try {
    await http
        .get("/api/states")
        .then((response) => {
          response.data.forEach((item) => {
            states.value.push({
              name: item.abbreviation,
              country_id: item.country_id,
            })
          })
        });
  } catch (e) {
    console.log(e.response.data.error);
  }
}

const getCountries = async () => {
  try {
    await http
        .get("/api/country")
        .then((response) => {
          response.data.forEach((item) => {
            countries.value.push({
              id: item.abbreviation,
              name: item.name,
              country_id: item.id
            })
          })
        });
  } catch (e) {
    console.log(e.response.data.error);
  }
}

const getData = async () => {
  try {
    await http
        .post("/api/checkout/verify-products", {
            products:btoa(new TextEncoder().encode(JSON.stringify(cartProducts.value)))
        })
        .then((response) => {

          response.data.check_prices.forEach((item)=>{
            let payload = {
              id: item.cartId,
              price: item.price
            }
            mainStore.updateProductPrice(payload);
          })

          if (response.data.user.subscriber != null) {
            formUser.value = response.data.user.subscriber;
            formUser.value.zip_code = response.data.user.subscriber.zip_code;
          }
          formUser.value.id = response.data.user.id;
          formUser.value.first_name = response.data.user.first_name;
          formUser.value.last_name = response.data.user.last_name;
          formUser.value.email = response.data.user.email;
          shippingAddresses.value = response.data.shipping;
          shippingAddresses.value.forEach((item) => {
            shipping_options.value.push({
              id: item.id,
              name: item.first_name + ', ' + item.last_name + ', ' + item.address + ', ' + item.city + ', ' + item.state + ', ' + item.zip_code + ',' + item.country
            })
          });

          if (response.data.user.extra != null) {
            formBilling.value = response.data.user.extra;
            formBilling.value.same_as_address = true;
          }
          if(shipping_id.value != null){
            formShipping.value.same_as_address = false;
            selectedShipping.value = parseInt(shipping_id.value);
            changeShippingAddress(selectedShipping.value,false);
          }
        });
  } catch (e) {
    if (e.response?.status === 401) {
      navigateTo('/login');
    }
    else{
      ready.value = true;
      window.scrollTo(0, 0);
      errors.value.push({message: 'Something went wrong! Please try again! If the problem persists, contact us.'});
      mainStore.destroyCart();
      setTimeout(() => {
        errors.value = [];
      }, 5000);
    }
    console.log(e.response.data.error);
  }
}

const onSubmit = async () => {
  ready.value = false;
  let valid_userForm = true;
  let valid_paymentForm = true;
  let valid_shippingForm = true;
  formCard.value.cardOwner = formUser.value.first_name + ' ' + formUser.value.last_name;

  if (userForm.value !== null) {
    await userForm.value.validate().then((valid) => {
      valid_userForm = valid.valid;
    });
  } else {
    valid_userForm = false;
  }

  if (paymentForm.value !== null) {
    await paymentForm.value.validate().then((valid) => {
      valid_paymentForm = valid.valid;
    });
  } else {
    valid_paymentForm = false;
  }

  if (orderType.value === 2) {
    if (!formShipping.value.same_as_address) {
      if (shippingForm.value !== null) {
        await shippingForm.value.validate().then((valid) => {
          valid_shippingForm = valid.valid;
        });
      } else {
        valid_shippingForm = false;
      }
    }
  }

  if (cartProducts.value.length <= 0) {
    ready.value = true;
    window.scrollTo(0, 0);
    errors.value.push({message: 'No products in cart!'});
    setTimeout(() => {
      errors.value = [];
    }, 5000);
    return 0;
  }
  if (((valid_userForm && valid_shippingForm && valid_paymentForm && Number(formOrder.value.total) !== 0) || (valid_userForm && valid_shippingForm && !valid_paymentForm && Number(formOrder.value.total) === 0))) {
    const payload = {
      userForm: formUser.value,
      billingForm: formBilling.value,
      shippingForm: formShipping.value,
      orderForm: formOrder.value,
      products: cartProducts.value,
      orderType: orderType.value,
      auto_renewal: formCard.value.autoRenewal,
      card: formCard.value,
    }
    try {
      await http.post('/api/checkout', payload,
      ).then((response) => {
        ready.value = true;
        finish.value = true;
        formUser.value = new OrderInformation();
        formShipping.value = new OrderInformation();
        formCard.value = new PaymentCard();
        mainStore.destroyCart();
        if(response.data.has_digital_photo)
        {
          digital_photos.value = response.data.order.transaction_id;
        }
      });
    } catch (e) {
      ready.value = true;
      window.scrollTo(0, 0);
      if (e?.response.data?.errors) {
        e.response.data.errors.forEach((error) => {
          errors.value.push({message: error});
        })
      } else {
        errors.value.push({message: e});
      }
      setTimeout(() => {
        errors.value = [];
      }, 5000);
    }
  } else {
    ready.value = true;
    window.scrollTo(0, 0);
    errors.value.push({message: 'Invalid Data. Please check your information!'});
    setTimeout(() => {
      errors.value = [];
    }, 5000);
  }
}

const cardData = () => {
  let year = new Date().getFullYear();
  for (let i = year; i <= year + 20; i++) {
    card_years.value.push({
      id: i,
      name: i
    })
  }
}

const start = async () => {
  ready.value = false;
  await mainStore.setProducts()
  cardData();
  await Promise.all([getTaxes(), getCountries(), getStates()]);
  await  getData();
  ready.value = true;
}

onMounted(() => {
  start();
})
</script>


<style scoped>
.v-select.vs--single .vs__dropdown-toggle{
  border: none;
}
.vs__open-indicator{
  fill: black;
}

 .billing-address{
  flex-direction: column!important;
}
</style>
